import React, { useEffect, useRef, useState } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

const ParallaxSection = () => {
  const sectionRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });

  const y1 = useTransform(scrollYProgress, [0, 1], [0, -150]);
  const y2 = useTransform(scrollYProgress, [0, 1], [0, -100]);
  const y3 = useTransform(scrollYProgress, [0, 1], [0, -50]);
  const opacity = useTransform(scrollYProgress, [0, 0.3, 0.7, 1], [0, 1, 1, 0]);

  const statements = [
    "Complexity demands clarity.",
    "Leadership defines outcomes.",
    "Execution is everything."
  ];

  return (
    <div ref={sectionRef} className="relative py-48 overflow-hidden bg-navy-darker">
      {/* Background Layers */}
      <motion.div
        style={{ y: y1, opacity: 0.05 }}
        className="absolute inset-0 bg-gradient-to-br from-white to-transparent"
      />
      
      {/* Statement Sections */}
      <div className="relative z-10 max-w-7xl mx-auto px-8">
        {statements.map((statement, index) => (
          <motion.div
            key={index}
            style={{
              y: index === 0 ? y1 : index === 1 ? y2 : y3,
              opacity
            }}
            className="mb-48 last:mb-0"
          >
            <motion.h2
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: '-100px' }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              className="text-6xl md:text-7xl font-bold text-white leading-tight tracking-tight"
            >
              {statement}
            </motion.h2>
            
            <motion.div
              initial={{ width: 0 }}
              whileInView={{ width: '200px' }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: index * 0.2 + 0.3 }}
              className="h-1 bg-white mt-8"
            />
          </motion.div>
        ))}
      </div>

      {/* Decorative Elements */}
      <motion.div
        style={{ y: y2 }}
        className="absolute top-1/4 right-0 w-96 h-96 bg-white opacity-5 rounded-full blur-3xl"
      />
      <motion.div
        style={{ y: y3 }}
        className="absolute bottom-1/4 left-0 w-96 h-96 bg-white opacity-5 rounded-full blur-3xl"
      />
    </div>
  );
};

export default ParallaxSection;
